import { render, staticRenderFns } from "./answer-number.vue?vue&type=template&id=0ee29494&scoped=true&"
import script from "./answer-number.vue?vue&type=script&lang=ts&"
export * from "./answer-number.vue?vue&type=script&lang=ts&"
import style0 from "./answer-number.vue?vue&type=style&index=0&id=0ee29494&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee29494",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VTextField})
